<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container @dialogConfirm="unblockDLPFileApiCall" />
    <div class="tab_ty1">
      <AuditTab :currentTab="2" />
      <div class="tab-content">
        <!-- 이력 Tab -->
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="2" :currentTab2="0" />
            <div class="tab-content">
              <div>
                <div class="tb-list_ty1 audit004">
                  <div class="tb-header clear">
                    <SelectBox
                        v-model="selectedDeptId"
                        valueProp = "deptId"
                        textProp = "deptName"
                        :disabled="view.disabled"
                        :excludes="view.selectExcludes"
                        div-cls="selectDiv"
                        :dtl-cd-list="depts.selectList"
                        v-if="deptList > 0 && roleIdCount == 1"
                        style="float: left; margin-top: 6px; margin-right: 20px;">
                    </SelectBox>
                    <div class="tb_num fl">
                      <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})"> 
                      </div>
                    </div>
                    <div class="search_ty2 fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="startDate"
                            :disabled-dates="startDisabledDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="endDate"
                            :disabled-dates="endDisabledDate"
                          ></datepicker>
                        </div>
                      </div>
                      <div class="search_ty2">
                        <input
                          type="text"
                          required
                          :placeholder="$i18nUtil.trans('message.FileCopyList.001','사용자명/사용자ID 검색')"
                          @focus="$event.target.placeholder = ''"
                          @focusout="
                            $event.target.placeholder = $i18nUtil.trans('message.FileCopyList.001','사용자명/사용자ID 검색')
                          "
                          v-model="searchUser"
                          @keyup.enter="getFileDlpBlockList()"
                        />
                        <button
                          type="button"
                          class="input-txt"
                          @click="getFileDlpBlockList()"
                        >
                          {{$i18nUtil.trans("search.039","검색")}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- //tb-header -->

                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="fileDlpBlockList"
                    hide-default-footer
                    class="tb-contents"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <div>
                            <span
                              :class="tenantId != 202 ? 'ell-singleline d-block cursor-pointer' : ''" 
                              @click="downloadFile(item)" 
                              style="width: 283px; overflow: hidden; text-overflow: ellipsis;"
                            >
                              {{ item.fileName }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.fileType }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.locationKbn }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.inoutKbn }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            {{
                              $moment(item.regDate).format("YYYY.MM.DD HH:mm")
                            }}
                          </div>
                        </td>
                        <td>
                          <div>
                            <span
                              >{{ item.regUserName }}({{
                                item.regUserId
                              }})</span
                            >
                          </div>
                        </td>
                        <td>
                          <div class="droplayer right list">
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <button
                                  type="button"
                                  class="btn-txt-link"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="viewBlockDesc(item.blockDesc)"
                                >
                                  {{$i18nUtil.trans("message.FileDlpBlockList.006","사유 보기")}}
                                </button>
                              </template>
                              <div class="dropdown-list">
                                <div class="top">{{ blockMessage }}</div>
                                <div class="scroll">
                                  <div class="list_box">
                                    <ul>
                                      <li
                                        v-for="(item, index) in blockData"
                                        :key="'pattern' + index"
                                      >
                                        <button
                                          type="button"
                                          class="ell-singleline"
                                          style="max-width: 100%"
                                        >
                                          {{ index + 1 }}.
                                          {{ blockData[index].pattern }} ({{
                                            blockData[index].count
                                          }}) : {{ blockData[index].content }}
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </v-menu>
                          </div>
                        </td>
                        <td>
                          <div>
                            <button
                              type="button"
                              class="label-fin"
                              @click="unblockDLPFile(item)"
                            >
                              {{$i18nUtil.trans("message.FileDlpBlockList.002","차단해제")}}
                            </button>
                          </div>
                        </td>
                      </tr>
                    </template>

                    <template slot="no-data">
                      <div class="nodata-txt-noicon">
                        <v-alert :value="true">
                          {{$i18nUtil.trans("message.FileDlpBlockList.007","파일DLP차단이력이 없습니다.")}}
                        </v-alert>
                      </div>
                    </template>
                  </v-data-table>

                  <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getFileDlpBlockList"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import SelectBox from "./common/SelectBox";

export default {
  components: {
    Datepicker,
    AuditSubTab,
    AuditTab,
    SelectBox,
  },
  data() {
    return {
      selectedDeptId : "",
      view : {
          selectExcludes : [],
          disabled : false
      },
      depts : {
          selectList : []
      },
      deptList : 0,
      roleIdCount : 0,
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      enabled: true,
      show: false,
      page: 1,
      pageCount: 0,
      totalCount: 0,
      itemsPerPage: 10,
      singleSelect: false,
      selected: [],
      headers: [
        { text: this.$i18nUtil.trans("entity.file.fileName","파일명"), value: "fileName", align: "center", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.fileType","파일타입"), value: "fileType", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.locationKbn","파일위치"), value: "locationKbn", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.inoutKubun","내외부구분"), value: "inoutKbn", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.regDate","등록일시"), value: "regDate", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.regUserId","등록사용자"), value: "regUserId", sortable: false },
        { text: this.$i18nUtil.trans("message.FileDlpBlockList.001","차단사유"), sortable: false },
        { text: this.$i18nUtil.trans("message.FileDlpBlockList.002","차단해제"), sortable: false },
      ],
      fileDlpBlockList: [],
      searchUser: "",
      startDate: new Date(this.$moment().subtract(1, "months")),
      endDate: new Date(this.$moment()),
      startDisabledDate: {
        from: new Date(this.$moment()),
      },
      endDisabledDate: {
        to: new Date(this.$moment().subtract(1, "months")),
      },
      blockData: [],
      blockMessage: "",
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      tenantId: localStorage.getItem("tenantId"),
    };
  },
  created() {
    this.getDeptList();
    // this.getFileDlpBlockList();
  },
  watch: {
    startDate() {
      this.page = 1;
      this.getFileDlpBlockList();
    },
    endDate() {
      this.page = 1;
      this.getFileDlpBlockList();
    },
    selectedDeptId() {
      this.page = 1;
      this.getFileDlpBlockList();
    },
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    /* 부서 리스트 조회 */
    getDeptList() {
      let obj = this;
      let reqData = {
        url : "/api/copaper/todo/getOrgDeptUserList",
        method : "post",
        params : {}
      };
      //프로그레스바 시작
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
            //프로그레스바 종료
            obj.hideLoadingbar();
            if(res.errorCode != null) {
              console.log(res.errorCode);
            }
            else {
              let deptName = '';
              let deptId = '';
              if(res.result.length > 1) {
                for(let i in res.result) {
                  if(i == 0) {
                      deptName = res.result[i].slice(0, res.result[i].indexOf(":"));
                      deptId = res.result[i].substring(res.result[i].indexOf(":")+1);
                      obj.depts.selectList.unshift({"deptName":deptName,"deptId":deptId});
                      obj.selectedDeptId = deptId;
                  } else {
                      deptName = res.result[i].slice(0, res.result[i].indexOf(":"));
                      deptId = res.result[i].substring(res.result[i].indexOf(":")+1);
                      obj.depts.selectList.push({"deptName":deptName,"deptId":deptId});
                  }
                }
                obj.deptList = res.result.length;
              }
              obj.getFileDlpBlockList();
            }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 파일DLP차단이력 목록 조회 */
    getFileDlpBlockList() {
      let obj = this;

      let reqData = {};
      reqData.params = {
        currentPage: obj.page,
        itemsPerPage: obj.itemsPerPage,
        startDate: obj.$moment(this.startDate).format("YYYYMMDD"),
        endDate: obj.$moment(this.endDate).format("YYYYMMDD"),
        searchUser: obj.searchUser,
        selectedDeptId: obj.selectedDeptId,
      };
      reqData.url = "/api/logging/audit/getFileDlpBlockList";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.fileDlpBlockList = res.result.fileDlpBlockList;
            obj.totalCount = res.result.fileDlpBlockCount;
            obj.pageCount = res.result.fileDlpBlockPageCount;
            obj.roleIdCount = res.result.roleIdCount; // 권한 개수
          }
          this.setDisabledDate();
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    setDisabledDate() {
      this.startDisabledDate.from = this.endDate;
      this.endDisabledDate.to = this.startDate;
    },
    viewBlockDesc(blockDesc) {
      let strBlockdesc = JSON.parse(blockDesc);

      this.blockMessage = strBlockdesc.detectedMessage;
      this.blockData = strBlockdesc.detectedFiles[0].data;
    },
    closeModal() {
      return ;
    },
    /* DLP차단해제 */
    unblockDLPFile(item) {
      let obj = this;
      obj.showConfirmDialogWithJSON({
        confirmMessage: "차단해제 하시겠습니까?", // obj.$i18nUtil.trans("message.FileDlpBlockList.003","차단해제 하시겠습니까?"),
        confirmBtnText: "해제", // obj.$i18nUtil.trans("button.dialog.unlink","해제"),
        confirmBtnCallback: obj.unblockDLPFileApiCall,
        modalParam: { item: item },
      });
    },
    /* DLP차단해제 Call*/
    unblockDLPFileApiCall(fileItem) {
      let obj = this;
      let reqData = {};
      reqData.params = fileItem.modalParam.item;
      reqData.url = "/api/cofile/paper/unblockDLPFile";
      reqData.method = "post";
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode != null) {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.FileDlpBlockList.004","차단해제 실패하였습니다.");
            obj.showToast(obj.toastInfo);
            obj.showLoadingbar(false);
          } else {
            this.updateDlpStatus(res.result.logId);
          }
        })
        .catch(function (err) {
          obj.toastInfo.message = obj.$i18nUtil.trans("message.FileDlpBlockList.004","차단해제 실패하였습니다.");
          obj.showToast(obj.toastInfo);
          obj.showLoadingbar(false);
          console.log(err);
        });
    },
    /* DLP차단해제 logging 테이블 unlock 업데이트*/
    updateDlpStatus(logId) {
      let obj = this;
      let reqData = {};
      reqData.params = { logId: logId };
      reqData.url = "/api/logging/audit/updateDlpStatus";
      reqData.method = "post";
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          obj.toastInfo.message = obj.$i18nUtil.trans("message.FileDlpBlockList.005","차단해제 되었습니다.");
          obj.showToast(obj.toastInfo);
          obj.hideLoadingbar();
          this.page = 1;
          this.getFileDlpBlockList();
        })
        .catch(function (err) {
          obj.toastInfo.message = obj.$i18nUtil.trans("message.FileDlpBlockList.004","차단해제 실패하였습니다.");
          obj.showToast(obj.toastInfo);
          obj.showLoadingbar(false);
          console.log(err);
        });
    },
    /* DLP파일 다운로드*/
    downloadFile(item) {
      if(this.tenantId != 202){
        let obj = this;
        let param = {};
        param.logId = item.logId;
        param.fileType = item.fileType;
        param.locationKbn = item.locationKbn;
        param.tenantId = obj.tenantId;
        param.fileName = item.fileName;
        param.filePath = item.filePath;
        // 프로그레스바 시작
        obj.showLoadingbar();
        obj.$axios({
          url: "/api/cofile/paper/downloadDLPFile",
          responseType: "blob",
          headers: {
            "Content-Type": "application/json"
          },
          method: "post",
          data: param
        })
        .then(res => {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          try {
            let blob = new Blob([res.data], {
              type: res.headers["content-type"]
            });
            // 에러코드 체크
            if(res.data.type.startsWith("application/json")) {
              let errorCode = obj.blobToString(blob);
              if(errorCode == "COFILE_FILE_DOWNLOAD_FAIL") {
                let info = {
                    title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                    contents: obj.$i18nUtil.trans("AB077"),
                    button: obj.$i18nUtil.trans("button.confirm","확인"),
                }
                obj.handleDialog(info);
                return;
              }
            }
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, item.fileName);
            } else {
              let link = document.createElement("a");
              link.target = "_self";
              link.setAttribute("download", item.fileName);
              link.href = window.URL.createObjectURL(blob);
              link.click();
              link.remove();
            }
          } catch (e) {
            obj.showAlertDialog(obj.$i18nUtil.trans("AB077"));
            console.error(e);
          }
        })
        .catch(res => {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          obj.showAlertDialog(obj.$i18nUtil.trans("AB077"));
          console.log(res);
        });
      }
    },
  },
};
</script>

<style scoped>
.audit004 {
  margin-top: 38px;
}
.audit004 >>> th:nth-child(1),
.audit004 >>> td:nth-child(1) {
  padding-left: 25px;
  width: calc(
    100% - 100px - 100px - 100px - 150px - 250px - 70px - 100px
  ) !important;
  text-align: left;
}
.audit004 >>> th:nth-child(2),
.audit004 >>> td:nth-child(2) {
  width: 100px !important;
  text-align: center;
}
.audit004 >>> th:nth-child(3),
.audit004 >>> td:nth-child(3) {
  width: 100px !important;
  text-align: center;
}
.audit004 >>> th:nth-child(4),
.audit004 >>> td:nth-child(4) {
  width: 100px !important;
  text-align: center;
}
.audit004 >>> th:nth-child(5),
.audit004 >>> td:nth-child(5) {
  width: 150px !important;
  text-align: center;
}
.audit004 >>> th:nth-child(6),
.audit004 >>> td:nth-child(6) {
  width: 250px !important;
  text-align: center;
}
.audit004 >>> th:nth-child(7),
.audit004 >>> td:nth-child(7) {
  width: 70px !important;
  text-align: center;
}
.audit004 >>> th:nth-child(8),
.audit004 >>> td:nth-child(8) {
  width: 100px !important;
  text-align: center;
}
.audit004 >>> th.text-center {
  text-align: center;
}
.audit004 >>> input {
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/FileDlpBlockList.vue